export function WhyChooseBuySection() {
  const features = [
    {
      icon: '/buy/Icon7.svg',
      title: 'Genuine 24K physical gold ownership',
      alt: 'Gold bars icon'
    },
    {
      icon: '/buy/Icon1.svg',
      title: 'Real-time, transparent pricing',
      alt: 'Chart icon'
    },
    {
      icon: '/buy/Icon2.svg',
      title: 'Secure digital gold wallet',
      alt: 'Shield icon'
    },
    {
      icon: '/buy/Icon3.svg',
      title: 'Insured UAE-wide delivery',
      alt: 'Package icon'
    },
    {
      icon: '/buy/Icon4.svg',
      title: 'Shariah-compliant gold investment',
      alt: 'Shariah compliant icon'
    },
    {
      icon: '/buy/Icon6.svg',
      title: 'ISO 27001 certified security',
      alt: 'ISO certificate icon'
    }
  ];

  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
         <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-[#192839] leading-tight text-center mb-12">
          Why Choose JustGold?
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              {/* Icon Container */}
              
                <img
                  src={feature.icon}
                  alt={feature.alt}
                  className="w-10 h-10"
                />
            
              {/* Feature Title */}
              <h3 className="max-w-[200px] text-[#57575c] text-md mt-4">
                {feature.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
